module.exports = __webpack_public_path__ + "assets/LDropPerpDetailed.e9c2f9b0b6cafe0709b088e1de403a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/LDropPerpDetailed.png
// module id = 531
// module chunks = 0